import React from 'react'
import PlansView from '../../components/views/plans-view/PlansView'

export default function PlansPage() {
  return (
    <PlansView />
  )
}